import tridentCampaigns from './trident-campaigns';
import ucdCampaigns from './ucd';

export default {
  tridentCampaigns,
  ucdCampaigns,
};
